<template>
  <!-- ========== 原有 Plan C (sr_i=134) 代碼 - 暫時註解保留 ========== -->
  <!--
  <div class="flex flex-col mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 plan-C" style="height:385px; width: 100%;">
    <div class="text-center">
        <h2 class="font-semibold text-yellow">
          {{ plansListCData.plan_c_title }}
        </h2>
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-plan-C">
      <div class="text-white">
        <p class="text-3xl">{{ plansListCData.plan_c_label_amount }}<span class="text-sm ml-2">/{{lang['components']['Plan']['PlanC']['time_unit']}}</span></p>
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400 text-sm">
      <li v-for="(item, index) in description" class="border-b">
          <div v-html="item"></div>
      </li>
    </ul>
    <button
      v-if="!useFbCustomize"
      class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm mb-2"
      @click="expCustomize"
    >
      流程體驗
    </button>
    <button v-if="plansListCData.plan_c_show" class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(134, 'C', '', 'fb')">
      {{ plansListCData.plan_c_text }}
    </button>
    <button v-else-if="!plansListCData.planHaveBind" class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(134, 'C', '', 'fb')">
      {{lang['components']['Plan']['PlanC']['pay_use']}}
    </button>
    <button
      v-else
      class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm"
      v-if="isExpiredData && (plansListCData.plan_c_text == '使用中' || plansListCData.plan_c_text == 'Using')"
      @click="handleChickPlan(134, 'C', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanC']['plan_item_payagain_button_text']}}
    </button>
  </div>
  -->
  <!-- ========== 原有代碼結束 ========== -->

  <!-- ========== 新版客製化方案 - D2-blue 卡片 ========== -->
  <div class="d2-plan-card-item">
    <div class="d2-plan-card-name" style="color: var(--amber);">客製化方案</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">依需求報價</span></div>
    <ul class="d2-plan-card-features">
      <li><i class="fas fa-check"></i> 彈性計價方案</li>
    </ul>
    <a
      href="https://line.me/R/ti/p/@964vjlme#~"
      target="_blank"
      rel="noopener noreferrer"
      class="d2-plan-card-btn try"
      style="text-decoration: none; display: block;"
    >
      聯絡客服
    </a>
  </div>
  <!-- ========== 新版客製化方案結束 ========== -->
</template>

<script>
export default {
  name: 'PlanC',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListC:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    useFbCustomize: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    expCustomize: {
      type: Function,
    }
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListCData: {
      get: function () {
        return this.plansListC
      },
      set: function (value) {
        this.$emit('update:plansListCData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListC.plan_c_description
    },
    isDisabled: function() {
       return this.plansListC.plan_c_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-C {
    &:hover {
      border: 2px #F7D676 solid;
    }
  }
</style>